<template>
    <PreSelectionCustom
        v-if="trip.searchFlow === TransferSearchFlow.Custom"
        v-bind="$props" />
    <PreSelectionAirport
        v-else-if="trip.searchFlow === TransferSearchFlow.Airport"
        v-bind="$props" />
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { TransferSearchFlow, TransferTrip } from '@/helpers/transfer/transfer.interfaces';
    import PreSelectionCustom from './PreSelectionCustom/PreSelectionCustom.vue';
    import PreSelectionAirport from './PreSelectionAirport/PreSelectionAirport.vue';

    export default defineComponent({
        name: 'TransferPreSelection',
        methods: { t },
        components: {
            PreSelectionCustom,
            PreSelectionAirport,
        },
        props: {
            trip: { type: Object as PropType<TransferTrip>, required: true },
            onSearch: { type: Function, required: true },
            onClose: { type: Function, required: true },
        },
        setup() {
            return { TransferSearchFlow };
        },
    });
</script>
